import { isParlayCard } from '../../../helpers';
import { getDaySuffix } from '../getDaySuffix';

const DAYS_OF_WEEK = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
const TODAY = 'TODAY';
const TOMORROW = 'TOMORROW';

export function formatDate(dateString: string, componentId: number): string {
    const date = new Date(dateString);
    const now = new Date();

    const isToday = date.toDateString() === now.toDateString();
    const isTomorrow = date.toDateString() === new Date(now.setDate(now.getDate() + 1)).toDateString();

    const dayOfWeek = DAYS_OF_WEEK[date.getDay()];
    const month = MONTHS[date.getMonth()];
    const day = date.getDate();
    const daySuffix = getDaySuffix(day);

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const isParlayCardComponent = isParlayCard(componentId);

    // if it's parlay card and isToday, return "TODAY" else return "TODAY" + fromated date
    if (isToday) {
        return isParlayCardComponent ? TODAY : `${TODAY} ${formattedHours}:${formattedMinutes}${ampm}`;
    }

    // if it's parlay card and isTomorrow, return "TOMORROW" else return "TOMORROW" + fromated date
    if (isTomorrow) {
        return isParlayCardComponent ? TOMORROW : `${TOMORROW} ${formattedHours}:${formattedMinutes}${ampm}`;
    }

    // if it is a parlay card or is not, and it is not today or tomorrow, return the formatted date
    return isParlayCardComponent
        ? `${dayOfWeek} ${month} ${day}${daySuffix}`
        : `${dayOfWeek} ${day}${daySuffix} ${month} ${formattedHours}:${formattedMinutes}${ampm}`;
}
